import React from "react";
import "./CollectionSummary.css";
import { CollectionProps } from "../../collectionUtils";

interface CollectionSummaryProps {
  collectionSummary: CollectionProps;
}
interface SummaryBox {
  label: string
  value: number
  backgroundColor: string
  valueColor: string
}

const CollectionSummary: React.FC<CollectionSummaryProps> = ({ collectionSummary }) => {

  const summaryStructure: SummaryBox[] = [
    {
      label: "Paid by Cash",
      value: collectionSummary.paidByCash,
      backgroundColor: "#ecf0ff",
      valueColor: "#1843cf"
    },
    {
      label: "Paid by UPI",
      value: collectionSummary.paidByUpi,
      backgroundColor: "#e9fff5",
      valueColor: "#179544"
    },
    {
      label: "Paid by Cheque",
      value: collectionSummary.paidByCheque,
      backgroundColor: "#f0fbff",
      valueColor: "#1bb4a2"
    },
    {
      label: "Paid by NEFT",
      value: collectionSummary.paidByNeft,
      backgroundColor: "#fef8ef",
      valueColor: "#d08e20"
    },
  ]

  return (
    <div className="delivery-summary-container">
      <div className="delivery-summary-left">
        <div className="delivery-summary-label">Collection Summary for today</div>
      </div>
      <div className="delivery-summary-right">
        {summaryStructure.map((summaryObject: SummaryBox, index: number) => (
          <>
            <div className="summary-box" style={{ backgroundColor: summaryObject.backgroundColor, padding: "5px 14px" }}>
              <div className="summary-box-label">{summaryObject.label}</div>
              <div className="summary-box-value" style={{ color: summaryObject.valueColor }}>₹ {summaryObject.value}</div>
            </div>
            {index < summaryStructure.length - 1 ? <div className="delivery_summary_vl"></div> : <></>}
          </>
        ))}
      </div>
    </div>
  );
};

export default CollectionSummary;